import script from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./BaseSnackbar.vue?vue&type=style&index=0&id=71a729f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a729f7"]])

export default __exports__